// Styles for SignIn go here.
import styled, { createGlobalStyle } from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import { constants } from '../../modules';

export const StyledSignInContainerDiv = styled.div<{ isReservation: boolean; isFlyOut: boolean }>`
  max-width: ${(props: { isReservation: boolean; isFlyOut: boolean }) =>
    props?.isReservation ? toRem(434) : props?.isFlyOut ? 'auto' : toRem(458)};
  .m-link-action {
    font-size: ${baseVariables.font.fontS};
  }
  .remember-me__text {
    &:first-letter {
      text-transform: uppercase;
    }
  }
  .width-mobile-100 {
    width: 100%;
    @media ${baseVariables.mediaQuery['sm']} {
      width: auto;
      &__flyout {
        min-width: ${toRem(132)};
      }
    }
  }
  .error-label,
  .error-label * {
    font-size: ${baseVariables.font.fontXs};
    color: ${baseVariables.color.alert50} !important;

    p {
      margin: 0;
      padding: 0;
    }
  }
  .accordion-container {
    .accordion-item {
      border-top: 0;
      .accordion-header {
        .accordion-button {
          border-top: 0;
          width: auto;
          .accordion-arrow-icon {
            line-height: 1;
          }
        }
      }
    }
  }
  .form-field-contaioner {
    .m-input-field {
      input {
        &:dir(rtl) {
          direction: rtl;
          text-align: end;
        }
        caret-color: ${baseVariables.color['neutral40']};
        &::-ms-reveal {
          display: none;
        }
      }

      &.is-error {
        &:focus-within {
          label {
            color: ${baseVariables.color.alert50};
          }
        }
        input:focus {
          box-shadow: none;
          ouline: 0;
        }
      }
      &.disabled {
        label {
          color: ${baseVariables.color.alert20};
        }
        input {
          border-color: ${baseVariables.color.alert20};
          outline: 0;
          color: ${baseVariables.color.neutral40} !important;
          &:focus {
            outline: 0;
            border-color: ${baseVariables.color.alert20};
            box-shadow: none;
          }
        }
      }
    }
    .rtl-fix-req {
      input {
        direction: ltr !important;
        text-align: end !important;
      }
    }
    .trailing-element {
      span {
        font-size: ${baseVariables.font.fontXl};
      }
    }

    input + span:not(.trailing-element) * {
      margin-bottom: 0;
      color: ${baseVariables.color.alert50};
      line-height: 1.3;
      padding-top: ${toRem(3)};
      padding-left: ${toRem(8)};
      padding-right: ${toRem(4)};
      a {
        font-weight: ${baseVariables.font.fontWeightBold};
      }
      u,
      a {
        padding: 0;
      }
    }
  }

  // changes for overridiing the css form homepage header.
  input[type='checkbox']:checked + label:after {
    display: block !important;
    background-color: transparent !important;
    content: '' !important;
    display: block !important;
    position: absolute !important;
    left: ${toRem(6)} !important;
    top: ${toRem(2)} !important;
    width: ${toRem(6)} !important;
    height: ${toRem(12)} !important;
    opacity: 1 !important;
    border-bottom: ${toRem(2)} solid ${baseVariables.color.base20} !important;
    border-right: ${toRem(2)} solid ${baseVariables.color.base20} !important;
    transition: border-color 0.3s ease !important;
  }

  input[type='checkbox']:checked + label:before {
    content: '' !important;
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    width: ${toRem(18)} !important;
    height: ${toRem(18)} !important;
    border: ${toRem(1)} solid ${baseVariables.color.base10} !important;
    border-radius: ${toRem(2)} !important;
    background: ${baseVariables.color.neutral00} !important;
    text-align: center !important;
  }

  .clear-remember-me {
    background-color: ${baseVariables.color.base20};
    &:is(${constants.ARABIC_LANG}) {
      line-height: ${toRem(24)} !important;
    }
  }

  // changes for eaa-fcp-error wrapper
  .eaa-fcp-error {
    .accordion {
      &__container {
        .accordion {
          &__heading {
            justify-content: flex-start;

            .accordion {
              &__title {
                margin: 0;
              }
            }

            .icon-arrow-down,
            .icon-arrow-up {
              margin-left: ${toRem(8)};
            }
          }
          &__list {
            margin-top: 0;
            padding-bottom: 0;
          }
        }
      }
    }
  }
  .eaa-sign-in-success-msg,
  .email-sign-in-success-msg {
    p {
      margin-bottom: 0;
    }
  }
  .trailing-element:focus-visible {
    .password-icon:before {
      border: ${toRem(2)} solid ${baseVariables.color.base10};
    }
  }
  .username-input {
    &__standard {
      label {
        max-width: 90%;
      }
    }
    &__inline {
      label {
        max-width: 99%;
      }
    }
    label {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .m-input-text-field
    input[type='password']:not([type='submit']):not([type='button']):not([type='checkbox']):not([type='radio']) {
    border: ${baseVariables.color.neutral30} solid ${toRem(1)};
    border-radius: ${toRem(8)};
    color: ${baseVariables.color.base10};
    font-size: ${baseVariables.font.fontM};
    line-height: ${baseVariables.font.lineHeightL};
    padding: ${toRem(26)} ${toRem(16)} ${toRem(8)};
    height: ${toRem(52)};
  }
  .m-input-text-field.is-error
    input[type='password']:not([type='submit']):not([type='button']):not([type='checkbox']):not([type='radio']) {
    border-color: ${baseVariables.color.alert50};
  }
  .m-input-text-field.is-error
    input[type='password']:not([type='submit']):not([type='button']):not([type='checkbox']):not([type='radio']):focus {
    border-color: ${baseVariables.color.alert50};
  }
  .m-input-text-field.is-error
    input[type='password']:not([type='submit']):not([type='button']):not([type='checkbox']):not([type='radio'])
    + span {
    color: ${baseVariables.color.alert50};
    font-size: ${baseVariables.font.fontXs};
    font-weight: ${baseVariables.font.fontWeightRegular};
    line-height: ${baseVariables.font.lineHeightS};
  }
  .m-input-text-field {
    .icon-visibility-off,
    .icon-visibility {
      font-size: ${baseVariables.font.fontXl};
    }
  }
  .password-error {
    .trailing-element {
      bottom: ${toRem(32)} !important;
    }
  }
  .grid-container-EAA {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
`;

//to override css for phase one
export const SignInEmailSuccessModalStyle = createGlobalStyle`
  .account-flyout-wrapper {
    margin-top: 0 !important;
    padding: ${toRem(8)} !important;
    @media ${baseVariables.mediaQuery.md} {
      padding: 0 !important;
    }
  }
  .container-modal-v2 {
    margin-top: 0 !important;
    @media ${baseVariables.mediaQuery.md} {
      padding-left: ${toRem(40)} !important;
      padding-right: ${toRem(40)} !important;
    }
  }
`;
